import epics, { observables as observablesGroup } from './epics/index'

export const observables = observablesGroup
export default epics
